<template>
  <div class="col-12 col-xl-12 col-md-12" style="margin-top: 1em">

    <!-- Patient Details -->
    <div class="mt-3">
      <div class="col-md-12 ">
        <h6>{{ $t("message.Lab Tests") }}</h6>
      </div>
      <card>
        <div class="col-md-12 pl-0">
          <ul>
            <li v-for="labtest in laborder.labTests" :key="labtest._id">
              {{labtest.name}}
            </li>
          </ul>
        </div>
      </card>
    </div>

    <div>
      <div class="col-md-12 ">
        <h6>{{ $t("message.Lab Reports") }}</h6>
      </div>
      <card>
        <div v-if="reports && reports.length>0" class="col-12 pl-0 list-wrapper" style="height:100%;">
          <file-card :showSearchBar="false" :files="reports" :show-add-button="false" :laborder="laborder" :patient-id="laborder.patient.patientId" :delete-control="false" :upload-control="false"></file-card>
        </div>
        <n-pagination v-if="reportsPagination.totalPages > 1" :page-count="reportsPagination.totalPages" v-model="reportsPagination.pageNumber"></n-pagination>
      </card>
    </div>
  </div>
</template>

<script>
import FileCard from "../components/FileCard.vue";

export default {
  name: "view-laborder",

  components: {
    FileCard,
  },

  props: ["laborder"],

  async mounted() {
    await this.getReports();
  },

  data() {
    return {
      reports: [],
      reportsPagination: {
        pageNumber: 1,
        totalPages: 0,
      },
    };
  },

  methods: {
    async getReports() {
      try {
        if (
          this.laborder &&
          this.laborder.patient &&
          this.laborder.patient.patientId
        ) {
          var query = {
            laborderId: this.laborder._id,
            patientId: this.laborder.patient.patientId,
          };

          let response = await this.$store.dispatch("getFiles", {
            query,
            pageNumber: this.reportsPagination.pageNumber,
            pageSize: "5",
          });

          this.reports = response.data;
          this.reportsPagination.totalPages = response.totalPages;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style>
</style>
